module.exports = __webpack_public_path__ + "static/media/14r.7fb68dea.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Deconstructed/14r.JPG
// module id = 310
// module chunks = 0